import React, { useEffect, useState } from 'react';
import { Table, Input, Button, Pagination, Popconfirm, Space, Tooltip, notification, App } from 'antd';
import { ReloadOutlined, PlusCircleOutlined, BookOutlined, EyeOutlined, EditOutlined, DeleteOutlined, DeleteFilled, GoldOutlined, SearchOutlined } from '@ant-design/icons';
import "../Pages/CSS/Traitement.css";
import { ImmoService } from '../Services/ImmoService';
import ImmobilisationModal from './ImmobilisationModal';
import moment from 'moment';
import ImmobilisationDetailModal from './ImmobilisationDetailModal';
import PassComptaImmo from './PassComptaImmoModal';

const Immobilisation = () => {
  const initialTableData = [];
  const [filteredData, setFilteredData] = useState(initialTableData);
    const [tabledata, setTableData] = useState(initialTableData);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImmo, setCurrentImmo] = useState(null);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedImmo, setSelectedImmo] = useState(null);
  const [comptaModalVisible, setComptaModalVisible] = useState(false);
  
  const immoService = new ImmoService();



const showDetailModal = (record) => {
  console.log(record);
    setSelectedImmo(record);
    setDetailModalVisible(true);
};

const closeDetailModal = () => {
    setDetailModalVisible(false);
};

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
         
          const result = await immoService.getAllImmo();
          setTableData(result); // Stocker les données dans l'état local
        } catch (error) {
          // Vous pourriez vouloir gérer l'erreur différemment
          console.error("Erreur lors de la récupération des données :", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchData();
    }, []);

    useEffect(() => {
      setFilteredData(tabledata); // Initialisation des données filtrées avec les données complètes au chargement
    }, [tabledata]);
    const showCreateModal = () => {
        setCurrentImmo(null); // Aucune immobilisation pour la création
        setIsModalVisible(true);
      };
      
    
    
      const showEditModal = (record) => {
        const formattedRecord = {
          ...record,
          date_acquis: record.date_acquis ? moment(record.date_acquis, "YYYY-MM-DD") : null,
          date_mes: record.date_mes ? moment(record.date_mes, "YYYY-MM-DD") : null,
        };
        setCurrentImmo(formattedRecord);
        setIsModalVisible(true);
      };
      
      
      const handleSave = async (immoData) => {
        console.log(immoData);
        setLoading(true);
        try {
          // Utiliser la présence de currentImmo pour décider entre ajout ou mise à jour
          const result = currentImmo
            ? await immoService.EddImmo({ ...immoData, id: currentImmo.code })
            : await immoService.AddImmo({...immoData});
      
          // Afficher une notification de succès
          notification.success({
            message: 'Succès',
            description: `L'immobilisation a été ${currentImmo ? 'mise à jour' : 'ajoutée'} avec succès.`,
          });
      
          // Recharger les données
          await reloadData();
        } catch (error) {
          // Afficher une notification d'erreur
          notification.error({
            message: 'Erreur',
            description: `Une erreur est survenue lors de la ${currentImmo ? 'mise à jour' : 'création'} de l'immobilisation.`,
          });
          console.error("Erreur lors de l'opération :", error);
        } finally {
          setLoading(false);
          setIsModalVisible(false);
        }
      };
      
      // Fonction pour recharger les données
      const reloadData = async () => {
        try {
          const result = await immoService.getAllImmo();
          setTableData(result);
        } catch (error) {
          console.error("Erreur lors de la récupération des données :", error);
        }
      };

      const DeleteImmo = async (record) => {
        setLoading(true);
        try {
          await immoService.deleteImmo(record.code);
          notification.success({
            message: 'Supprimé',
            description: 'L\'immobilisation a été supprimée avec succès.'
          });
          reloadData();
        } catch (error) {
          notification.error({

            message: 'Erreur',
            description: 'Une erreur est survenue lors de la suppression de l\'immobilisation.'
          });
        } finally {
          setLoading(false);
        }
      };
      
      const formatNumberWithSeparator = (number) => {
        return number.toLocaleString(); // Utilisez cette fonction pour formater les nombres
      };

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      sorter: (a, b) => {
        if (!a.code && b.code) return 1;
        if (a.code && !b.code) return -1;
        if (!a.code && !b.code) return 0;
        return a.code.localeCompare(b.code);
      },
    },
    {
      title: 'Désignation',
      dataIndex: 'designation',
      key: 'designation',
      sorter: (a, b) => {
        if (!a.designation && b.designation) return 1;
        if (a.designation && !b.designation) return -1;
        if (!a.designation && !b.designation) return 0;
        return a.designation.localeCompare(b.designation);
      },
    },
    {
      title: (
        <div style={{ backgroundColor: "#010f1c", color: "white", paddingRight: 5 }}>
          Valeur Acquisition
        </div>
      ),
      dataIndex: "val_acquis",
      key: "val_acquis",
      align: "right",
      sorter: (a, b) => (a.val_acquis ?? 0) - (b.val_acquis ?? 0),
      //render: (text) => <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>,
      render: (text) =><div style={{ paddingRight: 10 }}> <strong>{formatNumberWithSeparator(text)}</strong></div>,
    },
    {
      title: (
        <div style={{ backgroundColor: "#010f1c", color: "white", paddingRight: 5 }}>
          Durée
        </div>
      ),
      dataIndex: "duree_amort",
      key: "duree_amort",
      align: "right",
      sorter: (a, b) => (a.duree_amort ?? 0) - (b.duree_amort ?? 0),
      render: (text) => <div style={{ paddingRight: 10 }}>{parseFloat(text)}</div>,
    },
    {
      title: (
        <div style={{ backgroundColor: "#010f1c", color: "white", paddingRight: 5 }}>
          Taux
        </div>
      ),
      dataIndex: "taux",
      key: "taux",
      align: "right",
      sorter: (a, b) => (a.taux ?? 0) - (b.taux ?? 0),
      render: (text) => <div style={{ paddingRight: 10 }}>{parseFloat(text)} %</div>,
    },
    {
      title: 'Date Acquisition',
      dataIndex: 'date_acquis',
      key: 'date_acquis',
      align: 'center',
      sorter: (a, b) => {
        const dateA = a.date_acquis ? new Date(a.date_acquis).getTime() : 0;
        const dateB = b.date_acquis ? new Date(b.date_acquis).getTime() : 0;
        return dateA - dateB;
      },
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {text ? moment(text).locale("fr").format("DD/MM/YYYY") : "N/A"}
        </div>
      ),
    },
    {
      title: 'Mise en service',
      dataIndex: 'date_mes',
      key: 'date_mes',
      align: 'center',
      sorter: (a, b) => {
        const dateA = a.date_mes ? new Date(a.date_mes).getTime() : 0;
        const dateB = b.date_mes ? new Date(b.date_mes).getTime() : 0;
        return dateA - dateB;
      },
      render: (text) => (
        <div style={{ whiteSpace: "nowrap", textAlign: "center" }}>
          {text ? moment(text).locale("fr").format("DD/MM/YYYY") : "N/A"}
        </div>
      ),
    },
    {
      title: (
        <div style={{ backgroundColor: "#010f1c", color: "white", padding: "1px" }}>
        </div>
      ),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="View">
            <EyeOutlined
              style={{ cursor: "pointer", color: '#67f02e', marginRight: 8 }}
              onClick={() => showDetailModal(record)}
            />
          </Tooltip>
          <Tooltip title="Modifier">
            <EditOutlined
              style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
              onClick={() => showEditModal(record)}
            />
          </Tooltip>
          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer?"
            onConfirm={() => DeleteImmo(record)}
            okText="Oui"
            cancelText="Non"
          >
            <Tooltip title="Supprimer">
              <DeleteFilled style={{ cursor: "pointer", color: "red" }} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];
  

  const handleSearch = (value) => {
    const filtered = tabledata.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered);
  };
  
  return (
    <div style={{padding:12}}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <GoldOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Immobilisations
        </span>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
      <Input
        className="search-input-highlight"
        placeholder="Rechercher..."
        allowClear
        prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
        style={{ width: 250 }}
        onChange={(e) => handleSearch(e.target.value)}
        onPressEnter={(e) => handleSearch(e.target.value)}
      />
      <Space>

          <Button type="primary" icon={<PlusCircleOutlined />} onClick={showCreateModal} style={{ marginRight: 8 }}>
            Nouveau
          </Button>
          <Button icon={<BookOutlined />} onClick={() => setComptaModalVisible(true)} className="buttonCloture">
        Passation Comptable
      </Button>
      <PassComptaImmo isVisible={comptaModalVisible} tableData={tabledata} setIsVisible={setComptaModalVisible} />
          <Button  className="buttonRefresh"  icon={<ReloadOutlined />}>Actualiser</Button>
        </Space>
      </div>
      <Table
            className="custom-header2-table"
            bordered
            showSorterTooltip={false}
            columns={columns}
            dataSource={filteredData}
           
            
          />
            <ImmobilisationModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
        immobilisation={currentImmo}
        onSave={handleSave}
        //maskClosable={true}
      />
    <ImmobilisationDetailModal
    isVisible={detailModalVisible}
    onClose={closeDetailModal}
    immobilisation={selectedImmo}
/>
    </div>
  );
};

export default Immobilisation;
